const baseUrl = 'http://cms.carticletech.com:8090';
// const baseUrl = 'http://localhost:8080';

export default {
    login: `${baseUrl}/user/login`,

    getQaList: `${baseUrl}/qa/list`,
    addQa: `${baseUrl}/qa/add`,
    getQa: (id) => `${baseUrl}/qa/detail/` + id,
    updateQa: (id) => `${baseUrl}/qa/update/` + id,
    deleteQa: (id) => `${baseUrl}/qa/delete/` + id,

    getServiceCaseList: `${baseUrl}/service_case/list`,
    addServiceCase: `${baseUrl}/service_case/add`,
    getServiceCase: (id) => `${baseUrl}/service_case/detail/` + id,
    updateServiceCase: (id) => `${baseUrl}/service_case/update/` + id,
    deleteServiceCase: (id) => `${baseUrl}/service_case/delete/` + id,

    getNewsList: `${baseUrl}/news/list`,
    addNews: `${baseUrl}/news/add`,
    getNews: (id) => `${baseUrl}/news/detail/` + id,
    updateNews: (id) => `${baseUrl}/news/update/` + id,
    deleteNews: (id) => `${baseUrl}/news/delete/` + id,

    addImage: `${baseUrl}/image/add`,
    getImage: (name) => `${baseUrl}/image/get?name=` + name,

}
